import dynamic from '@/utils/dynamic';

const QuizPlayer = dynamic(() => import(/* webpackChunkName: "quiz-player" */ './QuizPlayer'));

export default QuizPlayer;
